module.exports = __webpack_public_path__ + "static/media/store1.31e0ce94.svg";